export default function setUpCustomization(customization)
{

    if (!customization || typeof customization !== "object") {
        throw new Error("Invalid customization: customization must be a non-null object.");
    }

    const customizationDeepCopy = structuredClone(customization);
    const buttons = ["button1", "button2"];

    for (let button of buttons) {
        if (Object.prototype.hasOwnProperty.call(customizationDeepCopy, button)) {
            if (customizationDeepCopy[button]?.url === undefined) {
                delete customizationDeepCopy[button].url;
            }
        }
    }

    if (!customizationDeepCopy?.image) {
        delete customizationDeepCopy.image;
    }

    return customizationDeepCopy;
}